import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { IssueReports } from '@/features/issue-reports'

// `?task=<id>` : ouvre cette tâche (lien « Voir la tâche » du tiroir document).
const searchSchema = z.object({
  task: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/issue-reports/')({
  validateSearch: searchSchema,
  component: IssueReports,
})
